import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  gap: 10px;
  padding: 8px;
`

export const WordCounter = styled.span`
  text-transform: uppercase;
  color: #274060;
`

export const PricePrivew = styled.span`
  color: #09f;
`
